var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTutorialColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_745_1250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8896 12.8203H13.9443V15.5203H12.8896V12.8203Z",
    fill: "#29185E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.416 12.1191C13.6918 12.1191 13.9561 11.8766 13.9433 11.5918C13.9305 11.3061 13.7116 11.0645 13.416 11.0645C13.1401 11.0645 12.8759 11.307 12.8886 11.5918C12.9014 11.8775 13.1203 12.1191 13.416 12.1191Z",
    fill: "#29185E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3472 8.97047V0H2.31768C1.03971 0 0 1.00912 0 2.28709V15.7505H0.0111445C0.128285 17.0104 1.19092 18 2.4808 18H13.423C15.9468 18 18 15.9774 18 13.4536C18 11.2464 16.4294 9.39909 14.3472 8.97047ZM13.2908 8.87871C10.967 8.94498 9.07175 10.7518 8.86511 13.0384H4.24146V1.02575H13.2908V8.87871ZM2.31768 1.02575H3.18509V13.0384H2.4808C1.95096 13.0384 1.45979 13.2059 1.05634 13.4899V2.28709C1.05634 1.59156 1.62218 1.02575 2.31768 1.02575ZM2.4808 16.9437C1.69534 16.9437 1.05634 16.3046 1.05634 15.5192C1.05634 14.7337 1.69534 14.0947 2.4808 14.0947H8.89116C8.9351 14.4068 9.01051 14.7088 9.11429 14.9976H2.67687V16.0539H9.65865C9.88784 16.3847 10.1594 16.6839 10.4655 16.9437H2.4808V16.9437ZM13.423 16.9742C11.4818 16.9742 9.90243 15.3949 9.90243 13.4536C9.90243 11.5124 11.4818 9.93301 13.423 9.93301C15.3643 9.93301 16.9437 11.5124 16.9437 13.4536C16.9437 15.3949 15.3643 16.9742 13.423 16.9742Z",
    fill: "#29185E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05908 3.08008H10.5944V4.13642H7.05908V3.08008Z",
    fill: "#29185E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.86523 5.37305H11.789V6.42939H5.86523V5.37305Z",
    fill: "#29185E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_745_1250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorialColor);
export default __webpack_public_path__ + "static/media/tutorial_color.53d9e147aa3a2a067c4639b69ab07dc7.svg";
export { ForwardRef as ReactComponent };